import http from '@/uteis/http'

import { importar } from '@/uteis/action/spi/importar'

const paeBackURL = '/d0593/pae-back/v1/protocolos/'

const post = (url, dados) => new Promise((resolve, reject) => {
  http.post(url, dados).then((response) => {
    return resolve(response.data)
  }).catch(err => {
    if (err.response.status !== 401) {
      return reject(err.response.data)
    }

    http.post(url, dados).then((response) => {
      return resolve(response.data)
    }).catch(() => {
      return reject(err.response.data)
    })
  })
})

export default class ProcessoElaboracaoService {
  async salvar (dados) {
    return post(paeBackURL, dados)
  }

  async importarProtocoloSPI (numeroProtocolo, dadosSessao, alteracoes) {
    const dados = importar(numeroProtocolo, dadosSessao, alteracoes)
    const url = `/d0593/pae-back/v1/spi/protocolos/${numeroProtocolo}/import`
    return post(url, dados)
  }

  async editar (values) {
    return new Promise((resolve, reject) => {
      http.put(paeBackURL, values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.put(paeBackURL, values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }

  async buscarProcessoParaEdicao (numeroProcesso) {
    const url = `${paeBackURL}${numeroProcesso}`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        let result
        if (response.data) {
          result = response.data
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.get(url).then((response) => {
          let result
          if (response.data) {
            result = response.data
          }

          return resolve(result)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }

  async excluirProcesso (numeroProcesso, usuarioDelecao) {
    const url = `${paeBackURL}${numeroProcesso}/usuario/${usuarioDelecao}`
    return new Promise((resolve, reject) => {
      http.delete(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.delete(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }

  async visualizarProcesso (numeroProcesso, nome, login) {
    const body = {
      aplicacao: 'pae',
      numeroProcesso: numeroProcesso,
      participante: {
        nome: nome,
        identificador: login,
        tipoIdentificador: 'LOGIN'
      }
    }

    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/controles/vizualizador', body)
        .then((response) => resolve(response.data.url))
        .catch(err => {
          if (err.response.status !== 401) {
            return reject(err.response.data)
          }

          http.post('/d0593/pae-back/v1/controles/vizualizador', body)
            .then((response) => resolve(response.data.url))
            .catch(() => {
              return reject(err.response.data)
            })
        })
    })
  }

  async buscarProtocoloSPI (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/spi/protocolos', { params: filtro }).then((response) => {
        let result
        if (response.data) {
          result = response.data
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.get('/d0593/pae-back/v1/spi/protocolos', { params: filtro }).then((response) => {
          let result
          if (response.data) {
            result = response.data
          }

          return resolve(result)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }

  async buscarProtocoloSPIPorNumeroProtocolo (numeroProtocolo) {
    return new Promise((resolve, reject) => {
      http.get(`/d0593/pae-back/v1/spi/protocolos/${numeroProtocolo}`).then((response) => {
        let result
        if (response.data) {
          result = response.data
        }

        return resolve(result)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.get(`/d0593/pae-back/v1/spi/protocolos/${numeroProtocolo}`).then((response) => {
          let result
          if (response.data) {
            result = response.data
          }

          return resolve(result)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }

  async statusImportacao (numeroProtocolo) {
    const url = `/d0593/pae-back/v1/spi/protocolos/${numeroProtocolo}/status`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401) {
          return reject(err.response.data)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err.response.data)
        })
      })
    })
  }
}
